import { ErrorBoundary, FallbackComponent, beforeSend } from 'bugsnag'
import React from 'react'
import ReactDOM from 'react-dom'
import './index.scss'
import 'belle-js/lib/icons.svg'
import 'belle-js/lib/icons-rich.svg'
import { Provider } from 'react-redux'

import store from './store'

import App from './App'
import connectApp from './connectApp'

const RenderedApp = connectApp(App)

ReactDOM.render((
  <ErrorBoundary beforeSend={beforeSend} FallbackComponent={FallbackComponent}>
    <Provider store={store}>
      <RenderedApp />
    </Provider>
  </ErrorBoundary>
), document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js